<ng-template vdrDialogTitle>
    {{ isDuplicateMode ? ('Duplicate Store ' + (existingStoreSite?.name || '')) : 'Create Store Site' }}
</ng-template>

<div class="modal-body">
    <p class="intro-text" *ngIf="!isDuplicateMode">
        Create a new store site for your business.
        <span *ngIf="!demoAccountControl.value">Enter a store name and a unique URL identifier.</span>
        <span *ngIf="demoAccountControl.value">Demo site URL identifier will be generated automatically.</span>
    </p>
    <p class="intro-text" *ngIf="isDuplicateMode">
        Duplicate an existing store site.<br/>
        You can customize the new store name and URL, and choose whether to copy
        pages from "{{ existingStoreSite?.name }}".
    </p>

    <!-- Store Name -->
    <vdr-form-field label="Store Name">
        <input type="text" [formControl]="nameControl" placeholder="Enter a name for your store" class="clr-input"
            (input)="onStoreNameChange()" (keyup.enter)="isFormValid() && submit()" />
        <vdr-form-field-control-error *ngIf="nameControl.hasError('required')" errorMessage="Store name is required">
        </vdr-form-field-control-error>
        <vdr-form-field-control-error *ngIf="nameControl.hasError('minlength')"
            errorMessage="Store name must be at least 3 characters">
        </vdr-form-field-control-error>
    </vdr-form-field>

    <!-- Store URL -->
    <vdr-form-field *ngIf="!demoAccountControl.value" label="Default Store URL" class="store-url-field">
        <div class="url-input-wrapper">
            <input type="text" [formControl]="identifierControl" placeholder="my-store"
                class="clr-input url-input"
                (keyup.enter)="isFormValid() && submit()" />
            <span class="url-suffix">
                .dealomega.com
            </span>
        </div>
        <vdr-form-field-control-error *ngIf="identifierControl.hasError('required')"
            errorMessage="Store URL is required">
        </vdr-form-field-control-error>
        <vdr-form-field-control-error *ngIf="identifierControl.hasError('pattern') && !demoAccountControl.value"
            errorMessage="Store URL must be lowercase alphanumeric or dashes (1-64 chars)">
        </vdr-form-field-control-error>
    </vdr-form-field>
    <!-- Availability validation messages -->
    <div class="availability-messages" *ngIf="!demoAccountControl.value">
        <small *ngIf="isVerifyingIdentifier" class="verifying">
            <span class="loading"></span>
            Checking availability...
        </small>
        <small *ngIf="!isVerifyingIdentifier && identifierAvailable === true && identifierControl.valid"
            class="available">
            <clr-icon shape="success-standard" class="is-solid"></clr-icon>
            This store URL is available
        </small>
        <small *ngIf="!isVerifyingIdentifier && identifierAvailable === false"
            class="taken">
            <clr-icon shape="exclamation-circle" class="is-solid"></clr-icon>
            This store URL is already taken
        </small>
    </div>

    <div *ngIf="userIsSuperAdmin" class="demo-settings">
        <vdr-form-field label="Demo Site">
            <label class="clr-checkbox-wrapper" *ngIf="!forceDemoMode">
                <input type="checkbox" [formControl]="demoAccountControl" />
                <span>Create as demo site (no subscription required)</span>
            </label>
            <span *ngIf="forceDemoMode">This store will be created as a demo site.</span>
        </vdr-form-field>

        <ng-container *ngIf="demoAccountControl.value">
            <p class="clr-subtext">
                Store identifier will be generated automatically on creation.
            </p>
            <vdr-form-field label="Demo Customer Name">
                <input type="text" [formControl]="demoCustomerNameControl" placeholder="Enter customer name" />
            </vdr-form-field>
            <vdr-form-field label="Demo Customer Email">
                <input type="email" [formControl]="demoCustomerEmailControl" placeholder="customer@example.com" />
                <vdr-form-field-control-error
                    *ngIf="demoCustomerEmailControl.hasError('email')"
                    errorMessage="Enter a valid email">
                </vdr-form-field-control-error>
            </vdr-form-field>
            <vdr-form-field label="Expiration Date">
                <input type="date" [formControl]="demoExpiresAtControl" />
            </vdr-form-field>
        </ng-container>
    </div>

    <!-- Duplicate options (only when an existing store site is provided) -->
    <div *ngIf="isDuplicateMode" class="duplicate-options">
        <br/>
        <vdr-form-field label="Duplicate pages from existing store">
            <div class="duplicate-toggle-group">
                <div class="duplicate-toggle">
                    <input
                        type="checkbox"
                        [formControl]="duplicatePagesControl"
                    />
                    <span>Copy pages from "{{ existingStoreSite?.name }}"</span>
                </div>
                <p class="clr-subtext duplicate-help-text">
                    If enabled, all pages from the source store site will be copied to the new store site.
                </p>
            </div>
        </vdr-form-field>
    </div>

    <div class="alert alert-warning warning-note">
        <clr-icon shape="exclamation-triangle"></clr-icon>
        <span>Note: Store URL cannot be changed after creation</span>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="!isFormValid()">
        {{ isDuplicateMode ? 'Duplicate Store Site' : 'Create Store Site' }}
    </button>
</div>
